import React, { useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { parseSafe } from '../../utils/HtmlUtil';
import BrandLogo from '../BrandLogo';
import FooterLinks from './FooterLinks';
import AppActions from '../../actions/app';
import TranslationUtil from '../../utils/TranslationUtil';
import { capitalizeBrand } from '../../utils/BrandUtil';

export function Footer(props) {
    const getPropsFromState = (state) => {
        const {
            brand, locale, footerLinks, getFooterLinks
        } = state.app;
        const { app } = state;
        const brandName = capitalizeBrand(brand);
        const translations = new TranslationUtil(
            app.translations,
            app.fallbackTranslations
        );
        const getTranslation = (suffix, params) => translations.getTranslation(`Vrbo.footer.${suffix}`, params);
        const compNotice = getTranslation('complianceNotice', { brandName });
        const earningsEst = getTranslation('earningsEst');
        const airbnbData = getTranslation('airbnb');
        const okcNotice = translations.getTranslation('Vrbo.footer.okc');
        const showAirBnbData = locale.display === 'en-us';

        return {
            brand,
            locale: locale.canonical,
            footerLinks,
            getFooterLinks,
            compNotice,
            earningsEst,
            airbnbData,
            okcNotice,
            showAirBnbData
        };
    };

    const {
        brand,
        locale,
        footerLinks,
        getFooterLinks,
        compNotice,
        earningsEst,
        airbnbData,
        okcNotice,
        showAirBnbData
    } = useSelector(getPropsFromState, shallowEqual);

    const dispatch = useDispatch();
    useEffect(() => {
        if (!brand || !locale) return;
        dispatch(AppActions.getFooterLinks(brand, locale));
    }, [dispatch, brand, locale]);

    const { footerHtml, logo } = footerLinks || {};
    const { showCompliance, showOkcNotice } = props;
    // safe default callStatus object to satisfy BrandLogo.propTypes in tests
    const safeCallStatus = getFooterLinks || {
        start: false,
        success: false,
        fail: false
    };

    return (
        <div className="ulx-footer">
            <div className="ulx-footer__center">
                {showCompliance && (
                    <div className="ulx-footer__compliance">
                        {showOkcNotice && okcNotice && (
                            <p className="ulx-footer__okc-notice">
                                {parseSafe(okcNotice)}
                            </p>
                        )}
                        <p>{`${compNotice}`}</p>
                        <p>{`${earningsEst}`}</p>
                        {showAirBnbData && <p>{`${airbnbData}`}</p>}
                    </div>
                )}
                <div className="ulx-footer__content">
                    <div className="ulx-footer__logowrapper">
                        {logo && <BrandLogo logo={logo} callStatus={safeCallStatus} isFooter />}
                    </div>
                    <div className="ulx-footer__linkswrapper">
                        <FooterLinks referrerBrand={brand} footerHtml={footerHtml} />
                    </div>
                </div>
            </div>
        </div>
    );
}

Footer.propTypes = {
    showCompliance: PropTypes.bool,
    showOkcNotice: PropTypes.bool
};

Footer.defaultProps = {
    showCompliance: false,
    showOkcNotice: false
};

Footer.displayName = 'Footer';
export default Footer;
